import { registerNotification } from './registry'

registerNotification('location:exit', {
  color: (_, theme) => theme.semantic.secondary,
  icon:  () => 'logout',
})